import { useMutation, useQueryClient } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/constants';
import churchDashboardService from '@/services/church-dashboard.service';

type ApproveNotificationVariables = {
  churchId: string;
  id: string;
};

export const useApproveNotificationMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ churchId, id }: ApproveNotificationVariables) =>
      churchDashboardService.approveNotification({ churchId, id }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.DASHBOARD_NOTIFICATIONS] });
    },
  });
};
